import { Number } from 'core-js'
import moment from 'moment'
import _ from 'lodash'
import crypto from 'crypto'

export const mdCrtpto = pwd => {
  let md5 = crypto.createHash('md5')
  md5.update(pwd)
  return md5.digest('hex')
}
/**
 * 保留2位小数，不足补 0
 */
export const toDecimal = x => {
  var f = parseFloat(x)
  if (isNaN(f)) {
    return false
  }
  var f = Math.round(x * 100) / 100
  var s = f.toString()
  var rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}
export const addEightHour = (val, data, line = '-') => {
  if (!val) return ''
  let type = line === '.' ? 'YYYY.MM.DD' : 'YYYY-MM-DD'
  let result = ''
  if (data === 'day') {
    result = moment(val)
      .add(8, 'hours')
      .format(type)
  } else {
    result = moment(val)
      .add(8, 'hours')
      .format(`${type} HH:mm:ss`)
  }
  return result
}
export const timeAddSecond = val => {
  if (!val) return ''
  return moment(val).format('YYYY-MM-DD HH:mm:ss')
}

export const setSession = (name, data) => {
  sessionStorage.setItem(name, JSON.stringify(data))
}
export const setLocal = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data))
}

export const getSession = name => {
  let data = sessionStorage.getItem(name)
  if (typeof data === 'string' && data !== 'undefined' && data) {
    try {
      return JSON.parse(data)
    } catch (e) {
      console.log('json报错————————————————————')
      console.log(e)
      return ''
    }
  } else {
    return ''
  }
}
export const getLocal = name => {
  let data = localStorage.getItem(name)
  if (typeof data === 'string' && data !== 'undefined' && data) {
    try {
      return JSON.parse(data)
    } catch (e) {
      console.log('json报错————————————————————')
      console.log(e)
      return ''
    }
  } else {
    return ''
  }
}
export const getQueryJSON = (url, name) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = url.substr(1).match(reg)
  if (r != null) {
    try {
      return JSON.parse(unescape(r[2]))
    } catch (e) {
      return unescape(r[2])
    }
  }
  return null
}

export const getParamsInUrl = url => {
  const params = url.split('?')

  const formattedParams =
    params.length > 1
      ? _.chain(params[1])
          .split('&')
          .map(_.ary(_.partial(_.split, _, '='), 1))
          .fromPairs()
          .value()
      : {}

  return formattedParams
}

export const backTop = () => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
}
export const getDistance = (data, isDistanceKM = false) => {
  if (data === 0) return 0
  if (!data) return ''
  data = Number(data)
  let distance = data / (isDistanceKM ? 1 : 1000)
  let result = Number(distance % 1 ? distance.toFixed(2) : distance)
  return result
}
export const upCase = value => {
  return value.toUpperCase()
}

export const linkToPromotion = route => {
  // "/test/sm/
  let { pathname, protocol, hostname, origin } = location
  let envArr = pathname.split('/')
  let env = envArr[1] === 'sm' ? '' : `/${envArr[1]}`
  // eslint-disable-next-line no-undef
  let href = process.env.NODE_ENV === 'production' ? origin + env + '/promotion/#/' + route : `${protocol}//${hostname}:8082/#/` + route
  window.location.href = href
}
export const isNum = value => {
  return typeof value === 'number' && !isNaN(value)
}
export const getRobotUrl = store => {
  const isProduct = store.state.isProduct
  const env = store.state.env
  // const openid = store.state.personWXInfor.openid
  // const CiamId = store.state.personWXInfor.CiamId
  let baseUrl = ''
  // let queryArr = ['tenantId=TyreO2O', 'isphone=1', 'channelId=TyreO2O', 'beinlay=2', `oid=${openid}`, `uid=${CiamId}`]
  let queryArr = ['channelId=TyreO2O', 'beinlay=2','title=梅赛德斯-奔驰客户服务','pageName=轮胎详情']
  let chatUrl = {
    prd: 'https://customer-inquiry-chat-plus.mercedes-benz.com.cn/web/modelb/customer/index.html#/',
    test: 'https://customer-inquiry-chat-plus-test.mercedes-benz.com.cn/web/modelb/customer/index.html#/',
    dev: 'https://customer-inquiry-chat-plus-dev.mercedes-benz.com.cn/web/modelb/customer/index.html#/'
  }
  if (isProduct) {
    baseUrl = chatUrl.prd
  } else {
    baseUrl = chatUrl.test
    // if (env === 'test' || env === 'uat') {
    //   baseUrl = chatUrl.test
    // }
    if (env === 'dev') {
      baseUrl = chatUrl.dev
    }
  }
  const query = queryArr.join('&')
  return `${baseUrl}?${query}&nonce=${Date.now()}`
}
